import { useAtomValue } from 'jotai';
import { isEqual } from 'lodash-es';
import { useCanEditScenario } from '../../hooks/useCanEditScenario';
import { IScenarioDataModel } from '../../../../../data-models/scenario.data-model';
import { scenariosByIdMapStateJ } from '../../../../../services/state/ScenariosStateJ';
import { prepareScenarioPayload } from '../form/scenarioFormUtils';

export function useAllowSave(scenario: Partial<IScenarioDataModel>) {
  const canEdit = useCanEditScenario(scenario);
  const savedScenario = useAtomValue(scenariosByIdMapStateJ(scenario.companyId ?? -1)).get(scenario.id ?? -1);

  return (
    canEdit &&
    (!savedScenario?.id || !isEqual(prepareScenarioPayload(savedScenario), prepareScenarioPayload(scenario)))
  );
}
